export default class Header {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.headerBrekpoint = 1020;
        this.body = document.querySelector('body');
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
            this.prevWw;
            this.timeOut;
        }
    }

    closeMobileNav = () => {
        this.mobileNav.classList.remove('open');
        this.body.classList.remove('nav-open');
    }

    collapseAll = () => {
        this.mSubNavToggle.forEach((mSubNav) => {
            const collapsable = mSubNav.nextElementSibling;
            collapsable.style.maxHeight = null;
        });
    }

    closeAllSubNavs = () => {
        this.subNavToggle.forEach((subNavToggle) => {
            const subNav = subNavToggle.closest('.nav-item').querySelector('.header-sub-nav');
            subNav.classList.remove('open');
        });
    }

    getElements = () => {
        this.mobileNav = this.passedElement.closest('body').querySelector('#TillitMobileNav');
        this.mSubNavToggle = this.mobileNav.querySelectorAll('.sub-nav-toggle');
        this.subNavToggle = this.passedElement.querySelectorAll('.sub-nav-toggle');
        this.hamburgerToggle = this.passedElement.querySelector('.js-nav-toggle');
        this.closeMobNav = this.mobileNav.querySelector('.js-main-nav-close');
        this.closeMobileNav();
        this.closeAllSubNavs();
        this.collapseAll();
    }

    addEventListeners = () => {
        window.addEventListener('resize', () => {
            if ( (this.prevWw < this.headerBrekpoint && window.innerWidth > this.headerBrekpoint) ||
                (this.prevWw > this.headerBrekpoint && window.innerWidth < this.headerBrekpoint) ) {
                    this.closeMobileNav();
                    this.closeAllSubNavs();
                    this.collapseAll();
                }
            this.prevWw = window.innerWidth;
            return null;
        });

        this.subNavToggle.forEach((subNavToggle) => {
            const subNav = subNavToggle.closest('.nav-item').querySelector('.header-sub-nav');

            subNavToggle.addEventListener('mouseenter', (e) => {
                e.preventDefault();
                clearTimeout(this.timeOut);
                this.closeAllSubNavs();
                subNav.classList.add('open');
            });

            subNavToggle.addEventListener('mouseleave', (e) => {
                this.timeOut = setTimeout(this.closeAllSubNavs, 500);
            });

            subNav.addEventListener('mouseleave', () => {
                this.timeOut = setTimeout(this.closeAllSubNavs, 500);
            });

            subNav.addEventListener('mouseenter', () => {
                clearTimeout(this.timeOut);
            });
        });

        ['click','ontouchstart'].forEach((evt) => {
            this.hamburgerToggle.addEventListener(evt, () => {
                this.mobileNav.classList.add('open');
                this.body.classList.add('nav-open');
            });

            this.mobileNav.addEventListener(evt, (e) => {
                if ( e.target && e.target.id === 'TillitMobileNav' ) {
                    this.mobileNav.classList.remove('open');
                    this.body.classList.remove('nav-open');
                }
            });

            this.closeMobNav.addEventListener(evt, () => {
                this.closeMobileNav();
            });
        });

        this.mSubNavToggle.forEach((mSubNavToggle) => {
            ['click','ontouchstart'].forEach((evt) => {
                mSubNavToggle.addEventListener(evt, () => {
                    const collapsable = mSubNavToggle.nextElementSibling;
                    if ( collapsable.style.maxHeight ) {
                        collapsable.style.maxHeight = null;
                    } else {
                        this.collapseAll();
                        collapsable.style.maxHeight = collapsable.scrollHeight + "px";
                    }
                });
            });
        });
    }

}